<div class="questions-top-bar">
    <div class="filter-section animate-fade-in-up">
        <div class="filter-header">
            <div class="page-header">
                <div class="title-wrapper">
                    <h2 class="header-title">Questions</h2>
                    <span class="header-subtitle">Manage your question bank and craft the perfect assessment.</span>
                </div>
            </div>
        </div>
    </div>
    <app-question-filters [activeTabIndex]="activeTabIndex" (applyFilters)="onApplyFilters($event)"
        (clearFilters)="onClearFilters()" (search)="onSearch($event)">
    </app-question-filters>
    <mat-tab-group dynamicHeight mat-stretch-tabs class='questions-tab-group' #questionsTabGroup
        (selectedTabChange)="tabChanged($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                Multiple Choice Questions ({{mcqsInfo.totalQuestions}})
            </ng-template>
            <div class="tab-actions-bar">
                <div class="expand-collapse-toggle-bar">
                    <button mat-stroked-button (click)="toggleExpandAll()">
                        <mat-icon>{{ allExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                    </button>
                    <button mat-stroked-button [matMenuTriggerFor]="mcqBulkMenu" style="margin-left: 8px;"
                        *ngIf="!showMcqBulkCheckboxes">
                        Bulk Actions <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <button mat-stroked-button color="warn" style="margin-left: 8px;" *ngIf="showMcqBulkCheckboxes"
                        (click)="onMcqBulkActionDone()">
                        Cancel
                    </button>
                    <button mat-flat-button color="warn" style="margin-left: 8px;"
                        *ngIf="showMcqBulkCheckboxes && hasSelectedMcqs" (click)="mcqsList.onBulkDelete()">
                        <mat-icon>delete</mat-icon> Delete Selected ({{selectedMcqCount}})
                    </button>
                    <mat-menu #mcqBulkMenu="matMenu">
                        <button mat-menu-item (click)="onMcqBulkAction('delete')"><mat-icon>delete</mat-icon>
                            Delete</button>
                        <button mat-menu-item disabled><mat-icon>block</mat-icon> Disable</button>
                    </mat-menu>
                </div>
                <button mat-stroked-button color="primary" class="new-question-btn" size="small"
                    (click)="createOrUpdateMcq()">
                    <mat-icon>add</mat-icon> Multiple Choice Question
                </button>
            </div>
            <app-mcqs-list #mcqsList [mcqsInfo]="mcqsInfo" [showCheckboxes]="showMcqBulkCheckboxes"
                (removeSelectedMCQ)="deleteMulChoiceQuestion($event)" (mcqScroll)="onMcqScroll()"
                (mcqCountChanged)="onMcqCountChanged($event)" (questionDeselected)="questionDeselected($event)"
                (bulkActionDone)="onMcqBulkActionDone()"
                (selectedMulChoiceQuestion)="onMcqEmptyStateAction($event)"></app-mcqs-list>
            <div class="load-more-loader" *ngIf="isLoadingMoreMcqs && activeTabIndex === 0">
                <div class="simple-spinner"></div>
                <span class="load-more-text">Loading more questions...</span>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Open Ended Questions ({{oeqsInfo.totalQuestions}})
            </ng-template>
            <div class="tab-actions-bar">
                <div class="expand-collapse-toggle-bar">
                    <button mat-stroked-button (click)="toggleExpandAll()">
                        <mat-icon>{{ allExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                    </button>
                    <button mat-stroked-button [matMenuTriggerFor]="oeqBulkMenu" style="margin-left: 8px;"
                        *ngIf="!showOeqBulkCheckboxes">
                        Bulk Actions <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <button mat-stroked-button color="warn" style="margin-left: 8px;" *ngIf="showOeqBulkCheckboxes"
                        (click)="onOeqBulkActionDone()">
                        Cancel
                    </button>
                    <button mat-flat-button color="warn" style="margin-left: 8px;"
                        *ngIf="showOeqBulkCheckboxes && hasSelectedOeqs" (click)="oeqsList.onBulkDelete()">
                        <mat-icon>delete</mat-icon> Delete Selected ({{selectedOeqCount}})
                    </button>
                    <mat-menu #oeqBulkMenu="matMenu">
                        <button mat-menu-item (click)="onOeqBulkAction('delete')"><mat-icon>delete</mat-icon>
                            Delete</button>
                        <button mat-menu-item disabled><mat-icon>block</mat-icon> Disable</button>
                    </mat-menu>
                </div>
                <button mat-stroked-button color="primary" class="new-question-btn" size="small"
                    (click)="createOrUpdateOeq()">
                    <mat-icon>add</mat-icon> Open-ended Question
                </button>
            </div>
            <app-oeqs-list #oeqsList [oeqsInfo]="oeqsInfo" [showCheckboxes]="showOeqBulkCheckboxes"
                (removeSelectedOEQ)="deleteOpenEndedQuestion($event)" (oeqScroll)="onOeqScroll()"
                (oeqCountChanged)="onOeqCountChanged($event)" (questionDeselected)="questionDeselected($event)"
                (bulkActionDone)="onOeqBulkActionDone()" (selectedOEQ)="onOeqEmptyStateAction($event)"></app-oeqs-list>
            <div class="load-more-loader" *ngIf="isLoadingMoreOeqs && activeTabIndex === 1">
                <div class="simple-spinner"></div>
                <span class="load-more-text">Loading more questions...</span>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Coding Questions ({{cqsInfo.totalQuestions}})
            </ng-template>
            <div class="tab-actions-bar">
                <div class="expand-collapse-toggle-bar">
                    <button mat-stroked-button (click)="toggleExpandAll()">
                        <mat-icon>{{ allExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                    </button>
                    <button mat-stroked-button [matMenuTriggerFor]="cqBulkMenu" style="margin-left: 8px;"
                        *ngIf="!showCqBulkCheckboxes">
                        Bulk Actions <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <button mat-stroked-button color="warn" style="margin-left: 8px;" *ngIf="showCqBulkCheckboxes"
                        (click)="onCqBulkActionDone()">
                        Cancel
                    </button>
                    <button mat-flat-button color="warn" style="margin-left: 8px;"
                        *ngIf="showCqBulkCheckboxes && hasSelectedCqs" (click)="cqsList.onBulkDelete()">
                        <mat-icon>delete</mat-icon> Delete Selected ({{selectedCqCount}})
                    </button>
                    <mat-menu #cqBulkMenu="matMenu">
                        <button mat-menu-item (click)="onCqBulkAction('delete')"><mat-icon>delete</mat-icon>
                            Delete</button>
                        <button mat-menu-item disabled><mat-icon>block</mat-icon> Disable</button>
                    </mat-menu>
                </div>
                <button mat-stroked-button color="primary" class="new-question-btn" size="small"
                    *ngIf="enableCreateCodingQuestions" (click)="createOrUpdateCQ()">
                    <mat-icon>add</mat-icon> Coding Question
                </button>
            </div>
            <app-cqs-list #cqsList [cqsInfo]="cqsInfo" [fromView]="'questions'" [showCheckboxes]="showCqBulkCheckboxes"
                (removeSelectedCQ)="deleteCodingQuestion($event)" (cqScroll)="onCqScroll()"
                (questionDeselected)="questionDeselected($event)" (bulkActionDone)="onCqBulkActionDone()"
                (selectedCQ)="onCqEmptyStateAction($event)"></app-cqs-list>
            <div class="load-more-loader" *ngIf="isLoadingMoreCqs && activeTabIndex === 2">
                <div class="simple-spinner"></div>
                <span class="load-more-text">Loading more questions...</span>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>